import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CustomTabs from '../../shared/CustomTabs'
import { useTabPersistence } from '../../hooks/useTabPersistence'
import ClaimBatchListTab from '../../components/his/claimgeneration/ClaimBatchListTab'
import ClaimBatchStepTab from '../../components/his/claimgeneration/ClaimBatchStepTab'
import ClaimErrorsTab from '../../components/his/claimgeneration/ClaimErrorsTab'

function Claims() {
  const { t } = useTranslation()
  const [selectedBatchId, setSelectedBatchId] = useState('')
  const [workflowListMonth, setWorkflowListMonth] = useState('')
  const {
    activeTabIndex,
    setActiveTabIndex,
    activeChildTabIndex,
    setActiveChildTabIndex
  } = useTabPersistence('claims_batch_flow_tabs', {})

  const handleBatchCreated = ({ currentStep, month }) => {
    const workflowTabIndexes = {
      audit: 1,
      auto_fix: 2,
      acknowledgment: 3,
      generate_claim: 4,
      generated_claim_audit: 5,
      generated_claim_auto_fix: 6,
      clearance: 7,
      submit_claim: 8
    }

    // The step tab opens its batch list first; the user chooses the eye icon to open details.
    setSelectedBatchId('')
    setWorkflowListMonth(month || '')
    setActiveTabIndex(workflowTabIndexes[currentStep] || 1)
  }
  const tabs = [
    {
      name: t('Batches'),
      content: () => (
        <ClaimBatchListTab
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          onBatchCreated={handleBatchCreated}
        />
      )
    },
    {
      name: t('Audit'),
      content: () => (
        <ClaimBatchStepTab
          mode='audit'
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          workflowListMonth={workflowListMonth}
        />
      )
    },
    {
      name: t('Auto Correct'),
      content: () => (
        <ClaimBatchStepTab
          mode='auto-fix'
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          workflowListMonth={workflowListMonth}
        />
      )
    },
    {
      name: t('Acknowledge'),
      content: () => (
        <ClaimBatchStepTab
          mode='acknowledge'
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          workflowListMonth={workflowListMonth}
        />
      )
    },
    {
      name: t('Generate Claim'),
      content: () => (
        <ClaimBatchStepTab
          mode='generate'
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          workflowListMonth={workflowListMonth}
        />
      )
    },
    {
      name: t('Generated Claim Audit'),
      content: () => (
        <ClaimBatchStepTab
          mode='generated-audit'
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          workflowListMonth={workflowListMonth}
        />
      )
    },
    {
      name: t('Generated Claim Auto Correct'),
      content: () => (
        <ClaimBatchStepTab
          mode='generated-auto-fix'
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          workflowListMonth={workflowListMonth}
        />
      )
    },
    {
      name: t('Clearance'),
      content: () => (
        <ClaimBatchStepTab
          mode='clearance'
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          workflowListMonth={workflowListMonth}
        />
      )
    },
    {
      name: t('Submit Claim'),
      content: () => (
        <ClaimBatchStepTab
          mode='submit'
          selectedBatchId={selectedBatchId}
          setSelectedBatchId={setSelectedBatchId}
          workflowListMonth={workflowListMonth}
        />
      )
    },
    {
      name: t('Errors'),
      content: () => <ClaimErrorsTab />
    }
  ]

  return (
    <div className='main-page-container !overflow-y-auto scrollbar'>
      <CustomTabs
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        activeChildTabIndex={activeChildTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        setActiveChildTabIndex={setActiveChildTabIndex}
      />
    </div>
  )
}

export default Claims
